import { render, staticRenderFns } from "./FooterComponentJnjts.vue?vue&type=template&id=05868069&scoped=true"
import script from "./FooterComponentJnjts.vue?vue&type=script&lang=ts"
export * from "./FooterComponentJnjts.vue?vue&type=script&lang=ts"
import style0 from "./FooterComponentJnjts.vue?vue&type=style&index=0&id=05868069&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05868069",
  null
  
)

export default component.exports